import { PDP_FEEDBACK } from "@/constants/index"

const pushAnalyticsObjToDataLayer = (eventInfo = {}) => {
  const page = window.pageObj || {}
  const event = "cmp:click"
  const { productInfo } = page
  window.adobeDataLayer.push({
    event,
    eventInfo,
    page,
    productInfo,
  })
}

export const addAnalyticsProvideFeedback = () => {
  const eventInfo = {
    eventAction: PDP_FEEDBACK,
    eventName: PDP_FEEDBACK,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "provide feedback",
    internalLinkPosition: "pdp",
    internalLinkType: PDP_FEEDBACK,
    clickInternalLinks: "false",
    internalLinkZoneName: PDP_FEEDBACK,
    internalLinkURL: "",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}
